import { Button, Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
  fileName: string;
  onRetry: () => void;
  onRemove: () => void;
}

export const FailedUploadChip = ({ fileName, onRetry, onRemove }: Props) => {
  const { t } = useTranslation();
  return (
    <Tag colorScheme="red" variant="subtle">
      <TagLabel>{fileName}</TagLabel>
      <Button variant="link" size="xs" colorScheme="red" mx="2" onClick={onRetry}>
        {t("Retry")}
      </Button>
      <TagCloseButton onClick={onRemove} />
    </Tag>
  );
};
